import autocompleteLocalization from '../autocomplete/localization.js'
import calendarLocalization from '../calendar/localization.js'
import comboboxLocalization from '../combobox/localization.js'
import commandMenuLocalization from '../command-menu/localization.js'
import datePickerLocalization from '../date-picker/localization.js'
import dateRangePickerLocalization from '../date-range-picker/localization.js'
import drawerLocalization from '../drawer/localization.js'
import layoutLocalization from '../layout/localization.js'
import messageLocalization from '../message/localization.js'
import modalLocalization from '../modal/localization.js'
import navToggleLocalization from '../nav-toggle/localization.js'
import notificationLocalization from '../notification/localization.js'
import numberFieldLocalization from '../number-field/localization.js'
import otpFieldLocalization from '../otp-field/localization.js'
import outlineLocalization from '../outline/localization.js'
import overflowListCountLocalization, { menuLocalization as overflowListMenuLocalization } from '../overflow-list/localization.js'
import paginationLocalization from '../pagination/localization.js'
import resizableLocalization, { resizableHandleLocalization } from '../resizable/localization.js'
import tagLocalization from '../tag/localization.js'
import textareaLocalization from '../textarea/localization.js'
import timePickerLocalization from '../time-picker/localization.js'
import timestampLocalization from '../timestamp/localization.js'

const en = {
  '$lang': 'en-US',
  '$name': 'English',
  '$dir': 'ltr' as 'ltr' | 'rtl',
  'nord-command-menu': commandMenuLocalization,
  'nord-combobox': comboboxLocalization,
  'nord-autocomplete': autocompleteLocalization,
  'nord-calendar': calendarLocalization,
  'nord-date-picker': datePickerLocalization,
  'nord-date-range-picker': dateRangePickerLocalization,
  'nord-drawer': drawerLocalization,
  'nord-layout': layoutLocalization,
  'nord-modal': modalLocalization,
  'nord-nav-toggle': navToggleLocalization,
  'nord-textarea': textareaLocalization,
  'nord-time-picker': timePickerLocalization,
  'nord-timestamp': timestampLocalization,
  'nord-notification': notificationLocalization,
  'nord-message': messageLocalization,
  'nord-number-field': numberFieldLocalization,
  'nord-otp-field': otpFieldLocalization,
  'nord-outline': outlineLocalization,
  'nord-overflow-list-count': overflowListCountLocalization,
  'nord-overflow-list-menu': overflowListMenuLocalization,
  'nord-pagination': paginationLocalization,
  'nord-resizable': resizableLocalization,
  'nord-resizable-handle': resizableHandleLocalization,
  'nord-tag': tagLocalization,
}

export default en
